import { createVanIconComponent } from "./van"

const WeappNav = createVanIconComponent("weapp-nav")
export default WeappNav
